import {
  Button,
  ButtonColor,
  ButtonWithIcon,
  ConfirmationModal,
  Loader,
  Message,
  SideModal,
  Text,
  Toggle,
} from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import { getProductName } from 'src/utilities/autoReport';
import { AutoReportCustomField } from './AutoReportCustomField/AutoReportCustomField';
import styles from './AutoReportFormSideModal.module.css';
import { DISBURSEMENT_PRODUCT } from './constants';
import { useAutoReportSideModalImpl } from './useAutoReportFormSideModalImpl';

type AutoReportSideModalProps = {
  isShowToggleActivated?: boolean;
  onParentClose?: () => void;
};

export const AutoReportSideModal = ({
  isShowToggleActivated = false,
  onParentClose,
}: AutoReportSideModalProps) => {
  const {
    state,
    onClose,
    onSubmit,
    onCloseCancelModal,
    onShowCancelModal,
    onToggleActivation,
    onDisable,
    onCloseDisableReportModal,
  } = useAutoReportSideModalImpl({
    onParentClose,
  });

  const {
    showSideModal,
    control,
    isShowCancelModal,
    data,
    isLoading,
    selectedProduct,
    isSubmitDisabled,
    isActive,
    forceEnableField,
    isFieldDisable,
    showCancelReportModal,
    isErrorMessageVisible,
  } = state;
  const { getTranslation } = useTranslate();

  return (
    <>
      {isLoading && <Loader isUsingBackdrop />}
      <ConfirmationModal
        show={showCancelReportModal}
        title={
          selectedProduct && DISBURSEMENT_PRODUCT.includes(selectedProduct)
            ? getTranslation(
                `settings_autoReport_nonActive_confirmation_${selectedProduct.toLowerCase()}`,
              )
            : undefined
        }
        description={
          selectedProduct && DISBURSEMENT_PRODUCT.includes(selectedProduct)
            ? getTranslation(
                'settings_autoReport_nonActive_confirmation_description',
              )
            : getTranslation('settings_autoReport_nonActive_confirmation')
        }
        primaryButtonColor={ButtonColor.Destructive}
        primaryButtonName={getTranslation('common_yes')}
        secondaryButtonName={getTranslation('common_cancelBatalkan')}
        onPrimaryButtonClick={onDisable}
        onSecondaryButtonClick={() =>
          onCloseDisableReportModal(isShowToggleActivated)
        }
      />
      <SideModal
        isUsingBackdrop
        show={showSideModal}
        onClose={onShowCancelModal}
      >
        <ConfirmationModal
          show={isShowCancelModal}
          description={getTranslation(
            'settings_autoReport_saveConfig_confirmation',
          )}
          primaryButtonColor={ButtonColor.Destructive}
          primaryButtonName={getTranslation('common_yes')}
          secondaryButtonName={getTranslation('common_back')}
          onPrimaryButtonClick={onClose}
          onSecondaryButtonClick={onCloseCancelModal}
        />
        <SideModal.Header showDivider>
          {getTranslation('common_autoReport')} -{' '}
          {selectedProduct && getTranslation(getProductName(selectedProduct))}
        </SideModal.Header>
        <SideModal.Body>
          {isLoading && <Loader isUsingBackdrop />}
          {!isLoading && (
            <div className={styles.bodyContainer}>
              {isShowToggleActivated && (
                <div className={styles.containerActivated}>
                  <Text textStyle={Text.Style.BodyMdSemibold}>
                    {getTranslation(`setting_autoReport_message`)}
                  </Text>
                  <Toggle
                    checked={isActive}
                    onChange={() => onToggleActivation()}
                  ></Toggle>
                </div>
              )}
              {(!isShowToggleActivated || isActive || isFieldDisable) && (
                <>
                  <Message showIcon>
                    <ul className={styles.ulMessage}>
                      <li className={styles.liMessage}>
                        {selectedProduct === 'BULK_DISBURSEMENT'
                          ? getTranslation(
                              'settings_autoReport_message_linkDownload_bulkDisbursement',
                            )
                          : getTranslation(
                              'settings_autoReport_message_linkDownload',
                            )}
                      </li>
                      <li>
                        {getTranslation(
                          'settings_autoReport_message_customColumn',
                        )}
                      </li>
                    </ul>
                  </Message>
                  {data
                    ?.filter(item => item.parameter !== 'IS_ACTIVE')
                    .map(item => {
                      const {
                        parameter,
                        required,
                        parameter_type,
                        value_option,
                      } = item;
                      return (
                        <AutoReportCustomField
                          key={`${parameter}`}
                          isDisabled={!forceEnableField}
                          control={control}
                          isRequired={required}
                          name={parameter}
                          type={parameter_type}
                          parameter={parameter}
                          options={
                            value_option ? value_option.split(';') : undefined
                          }
                          isErrorMessageVisible={isErrorMessageVisible}
                        />
                      );
                    })}
                </>
              )}
            </div>
          )}
        </SideModal.Body>
        <SideModal.Footer>
          <div className={styles.footerContainer}>
            <Button
              onClick={onShowCancelModal}
              buttonType={Button.Type.Outlined}
              color={Button.Color.Secondary}
            >
              {getTranslation('common_cancelBatalkan')}
            </Button>
            <ButtonWithIcon
              disabled={isSubmitDisabled}
              iconName="save"
              onClick={onSubmit}
            >
              {getTranslation('common_save')}
            </ButtonWithIcon>
          </div>
        </SideModal.Footer>
      </SideModal>
    </>
  );
};
